/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect } from 'react';
import {
  Tree,
  Checkbox,
  Popconfirm
} from 'antd';
import { DownOutlined } from '@ant-design/icons';

const { TreeNode } = Tree;

const HierarchyModal = (props) => {
  const [treeData, setTreeData] = useState(props.treeData || []);
  const [checkedArray, setCheckedArray] = useState(props.checkedArray || []);

  useEffect(() => {
    if (
      checkedArray !== props.checkedArray ||
      treeData !== props.treeData
    ) {
      setCheckedArray(props.checkedArray);
      setTreeData(props.treeData);
    }
  }, [props.checkedArray, props.treeData]);

  const setTranslation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getTextOnChange = (itemData) => {
    const { MainAliasCode, Name } = itemData;
    const { checkedArray, handleDropdownChange } = props;

    const itemExists = checkedArray.some((e) => e === MainAliasCode);
    let updatedArray;

    if (itemExists) {
      updatedArray = checkedArray.filter((val) => val !== MainAliasCode);
    } else {
      updatedArray = [...checkedArray, MainAliasCode];
    }

    handleDropdownChange(updatedArray, Name);
  };

  const getImmediateChildrenCodes = (parentNode) => {
    if (!parentNode.children || !parentNode.children.length) return [];

    return parentNode.children
      .filter(child => child.ParentId === parentNode.Id)
      .map(child => child.MainAliasCode);
  };

  const renderTreeNodes = (data) => {
    const { checkedArray, selectedOption, handleDropdownChange } = props;

    return data.map((item) => {
      const hasChildren = item.children && item.children.length > 0;

      const isMatchingType =
        (['Asset', 'AssetType'].includes(item.Type) && selectedOption === 'Asset') ||
        (['Device', 'DeviceType', 'SubDeviceType'].includes(item.Type) && selectedOption === 'Device');

      const renderTitle = () => {
        const displayCode = item.DisplayCode ? setTranslation(item.DisplayCode) : '';
        const displayName = item.Name ? `(${setTranslation(item.Name)})` : '';

        if (isMatchingType && ['DeviceType', 'AssetType', 'SubDeviceType'].includes(item.Type)) {
          return (
            <div>
              <Popconfirm
                title={setTranslation(
                  'You have selected to apply the planned hours to all the selected equipment type. Are you sure you want to proceed ?'
                )}
                onConfirm={() => {
                  const childCodes = getImmediateChildrenCodes(item);
                  const updatedArray = Array.from(
                    new Set([...checkedArray, ...childCodes, item.MainAliasCode])
                  );
                  handleDropdownChange(updatedArray, item.Name);
                }}
                onCancel={() => {
                  const childCodes = getImmediateChildrenCodes(item);
                  const updatedArray = checkedArray.filter(
                    code => code !== item.MainAliasCode && !childCodes.includes(code)
                  );
                  handleDropdownChange(updatedArray, item.Name);
                }}
                okText={setTranslation('Ok')}
                cancelText={setTranslation('Cancel')}
              >
                <Checkbox
                  key={item.Id}
                  checked={
                    checkedArray &&
                    Array.isArray(checkedArray) &&
                    checkedArray.includes(item.MainAliasCode)
                  }
                  value={item.MainAliasCode}
                />
              </Popconfirm>

              <span >
                {`${displayCode} ${displayName}`}
              </span>
            </div>
          );
        }

        else if (isMatchingType) {
          return (
            <div className="item-row">
              <Checkbox
                key={item.Id}
                onClick={() => getTextOnChange(item)}
                checked={
                  checkedArray &&
                  Array.isArray(checkedArray) &&
                  checkedArray.includes(item.MainAliasCode)
                }
                value={item.MainAliasCode}
              />
              <span>
                {`${displayCode} ${displayName}`}
              </span>
            </div>
          );
        }

        return <span>{`${displayCode} ${displayName}`}</span>;
      };

      if (hasChildren && item.Type === 'Device' && selectedOption === 'Device') {
        return (
          <TreeNode title={renderTitle()} key={item.Id} dataRef={item}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }

      return (
        <TreeNode key={item.Id} title={renderTitle()} dataRef={item}>
          {hasChildren && renderTreeNodes(item.children)}
        </TreeNode>
      );
    });
  };

  return (
    <div
      style={{
        borderRight: '1px dashed white',
        width: '100%',
        flex: '35%',
        overflowY: 'auto',
        height: window.innerHeight - 250
      }}
    >
      <Tree
        className="hierarchyTree"
        showLine
        checkedKeys={checkedArray}
        // defaultExpandAll={true}
        switcherIcon={<DownOutlined />}
      >
        {renderTreeNodes(treeData)}
      </Tree>
    </div>
  );
};

export default HierarchyModal;
